import { FC } from 'react';
import { OperatorResponse } from 'src/apis/contract-management/types';
import { FinancialSecuritiesRequest } from 'src/apis/contract-management/use-financial-securities';
import { Card } from 'src/components/data-display/card';
import { Stack } from 'src/components/layout/stack';
import { Link } from 'src/components/navigation/link';
import { Heading } from 'src/components/text/heading';
import { Successful } from 'src/hooks/use-axios';
import { useSaveReferrer } from 'src/hooks/use-referrer2';
import { TsoRequest } from 'src/pages/market-information/players/operators-detail/use-tso';
import { FinancialSecuritiesTable } from 'src/pages/operators/assignments/details/components/financial-securities-table';
import { Spacer } from 'src/pages/settings/registration/components/form-utils';

type Props = {
  tso: Successful<TsoRequest>;
  operator: OperatorResponse;
  financialSecurities: FinancialSecuritiesRequest;
};

export const FinancialSecurities: FC<Props> = ({
  tso,
  operator,
  financialSecurities,
}) => {
  const savedReferrer = useSaveReferrer({
    label: tso.response.data.name,
  });

  if (
    !operator._links.contractsForFinancialSecurity ||
    !operator._links.getFinancialSecurities ||
    !operator._links.submitCashDeposit ||
    !operator._links.submitRating ||
    !operator._links.submitBankGuarantee ||
    !operator._links.submitParentCompanyGuarantee
  )
    return null;

  return (
    <Card>
      <Stack flow="column" justifyContent="space-between" gap={2}>
        <Heading mode="card">Financial Securities</Heading>
        <Link
          data-testid="submit-financial-security"
          size="small"
          mode="button-secondary"
          to={savedReferrer.attachTo(
            `/operators/assignments/operators/${operator.id}/submit-financial-security`
          )}
        >
          Submit Financial Security
        </Link>
      </Stack>
      <Spacer />
      <FinancialSecuritiesTable
        referrer={savedReferrer}
        detailsPath={`/operators/assignments/operators/${operator.id}`}
        financialSecurities={financialSecurities}
      />
    </Card>
  );
};
